import React, {useEffect} from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useSelector} from 'react-redux';
import {TouchableOpacity, View, Linking} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

///////////////////////////
///////////// components
import {BodyText, CloseIconButton} from 'src/Modules/CommonView';
import TextMultiChoice from 'src/ScavengerHunt_v2/Challenges/TextMultiChoice';
import LinkChallenge from 'src/ScavengerHunt_v2/Challenges/LinkChallenge';
import PhotoVideo from 'src/ScavengerHunt_v2/Challenges/PhotoVideo';
import NumberGuesser from 'src/ScavengerHunt_v2/Challenges/NumberGuesser';
import LetterScramble from 'src/ScavengerHunt_v2/Challenges/LetterScramble';

import {markClassicLocationAllComplete} from 'src/Utils/huntFunctions_classic';

import {ContinueButton} from '../../Modules/CommonView/Buttons';
import FastImage from '../../Utils/FastImage';

import {useChallenge, useGameDebugInfo} from '../../Hooks/gameHooks';
import {navigationRef} from 'src/Nav/navigationHelpers';

const ChallengeAttemptModal = () => {
  const {width} = useWindowDimensionsSafe();

  const allChallenges = useSelector(
    (state) => state.game_v2?.allChallenges || {},
  );
  const locations = useSelector((state) => state.game_v2?.locations) || {};
  const groupId = useSelector((state) => state.groupInfo?.groupId);

  const challenge = useChallenge() || {};
  const gameDebugInfo = useGameDebugInfo();

  const currentScreenIsTheChallengeAttemptModal = useSelector(
    (state) => state.current_screen?.currentScreen === 'ChallengeAttemptModal',
  );

  useEffect(() => {
    // auto navigation if someone else completes the challenge
    if (!!challenge?.completeTime && currentScreenIsTheChallengeAttemptModal) {
      navigationRef.goBack(null);
      return navigationRef.navigate('ChallengeResultModal', {
        challengeId: challenge.challengeId,
      });
    }
  }, [challenge?.completeTime, currentScreenIsTheChallengeAttemptModal]);

  const handleOnComplete = () => {
    const {challengeId, locationId, type} = challenge;

    if (locationId) {
      //aka location challenges
      const location = locations[locationId];

      const allChallengesComplete = location.challengeList.every((key) => {
        let locaChallenge = allChallenges[key];

        console.log('testing if all challenges complete', {
          key,
          challengeId,
          locaChallenge,
        });

        return !!locaChallenge?.completeTime || key == challengeId;
      });

      if (allChallengesComplete) {
        markClassicLocationAllComplete({groupId, locationId});
      }
    }

    if (type !== 'photo' && type !== 'video') {
      navigationRef.goBack(null);
      return navigationRef.navigate('ChallengeResultModal', {
        challengeId: challengeId,
      });
    }
  };

  const {type, question = '', hintURL, challengePhoto} = challenge;
  console.log({challenge});

  const basePhotoUrl = 'photos.letsroam.com';
  const largeDisplayedPhoto = challengePhoto
    ? `https://${basePhotoUrl}${challengePhoto && challengePhoto.substring(1)}`
    : null;

  console.log({largeDisplayedPhoto});

  return (
    <SafeAreaView style={{flex: 1, justifyContent: 'flex-end'}}>
      <TouchableOpacity
        style={{flex: 1}}
        onPress={() => navigationRef.goBack(null)}
      />
      <View
        style={{
          width,
          backgroundColor: global?.color?.white,
          borderRadius: 10,
          paddingVertical: 5,
          position: 'relative',
        }}>
        <View style={{paddingBottom: 100, marginHorizontal: 10}}>
          <BodyText
            text={'Challenge' + gameDebugInfo}
            textStyle={{
              textAlign: 'center',
              fontWeight: '700',
              fontSize: 18,
              lineHeight: 20,
              marginTop: 20,
            }}
          />
          {largeDisplayedPhoto && (
            <View>
              <FastImage
                source={{uri: largeDisplayedPhoto}}
                style={{
                  width: width - 20,
                  height: 150,
                  marginTop: 10,
                  marginBottom: 10,
                }}
                resizeMode={FastImage?.resizeMode?.cover}
              />
            </View>
          )}
          <BodyText text={question?.replace()} />

          {(type === 'true_false' || type === 'multiple_choice') && (
            <TextMultiChoice
              onComplete={handleOnComplete}
              challenge={challenge}
              singleCompletion
              allowMultiGuess
              noTimer
            />
          )}
          {type === 'link' && (
            <LinkChallenge
              onComplete={handleOnComplete}
              challenge={challenge}
              singleCompletion
              allowMultiGuess
              noTimer
            />
          )}
          {(type === 'photo' || type === 'video') && (
            <PhotoVideo
              challenge={challenge}
              singleCompletion
              onComplete={handleOnComplete}
            />
          )}
          {(type === 'number_guesser' || type === 'numberguesser') && (
            <NumberGuesser
              onComplete={handleOnComplete}
              challenge={challenge}
              singleCompletion
            />
          )}
          {type === 'fill_in_the_blank' && (
            <LetterScramble
              onComplete={handleOnComplete}
              challenge={challenge}
              singleCompletion
            />
          )}
          {!!hintURL && (
            <ContinueButton
              text={'Need A Hint: Tap Here!'}
              handlePress={() => {
                Linking?.openURL(hintURL);
              }}
            />
          )}
        </View>
        <CloseIconButton
          handlePress={() => navigationRef.goBack(null)}
          side="right"
        />
      </View>
    </SafeAreaView>
  );
};

export default ChallengeAttemptModal;
